module.exports = __webpack_public_path__ + "5365dd495773d9e67e7c8fd6ab6e0745.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-brushed-copper.png
// module id = gUl9
// module chunks = 5